import './Header.css'

function HeaderYokai() {
  return (
    <header>
      <div className="ko-header">
        <h1>KinkiYokai</h1>
        <menu>
          <li><a href="/">Ko-Tyat-Ki Kollektiv.</a></li>
        </menu>
      </div>    
    </header>
  )
}

export default HeaderYokai
